import { render, staticRenderFns } from "./SystemBuilderQuickstart.vue?vue&type=template&id=5437bbc7&"
import script from "./SystemBuilderQuickstart.vue?vue&type=script&lang=js&"
export * from "./SystemBuilderQuickstart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports